import React from 'react';

import { PassingFeesType, SettingKeys } from '@invoice-simple/common';

import InvoiceModel from 'src/models/InvoiceModel';
import { useIsPaymentsEnabled } from 'src/payments/hooks/useIsPaymentsEnabled';
import { AppStore } from 'src/stores/AppStore';
import { InvoicePaymentDeposit } from './InvoicePaymentsDeposit/InvoicePaymentDeposit';
import { InvoicePaymentSurchargeFees } from './InvoicePaymentsSurcharge/InvoicePaymentSurchargeFees';
import { InvoiceSimplePayments } from './InvoiceSimplePayments';

export const InvoicePayments = (props: { store: AppStore }) => {
  const isPaymentsEnabled = useIsPaymentsEnabled();

  if (!isPaymentsEnabled) {
    return null;
  }
  const { store } = props;
  const invoice: InvoiceModel = store.doc;
  return (
    <>
      <InvoiceSimplePayments />
      <InvoicePaymentSurchargeFees
        invoice={invoice}
        feesType={
          store.user.settingList.getSetting(SettingKeys.PaymentFeesType)?.valNum === 1
            ? PassingFeesType.SURCHARGE
            : PassingFeesType.MARKUP
        }
      />
      <InvoicePaymentDeposit invoice={invoice} />
    </>
  );
};
